import React from 'react';
import Navbar from '../components/Navbar';
import PollioHero from '../components/PollioHero';
import PollioFeatures from '../components/PollioFeatures';
import PollioLivePreview from '../components/PollioLivePreview';

const PollioPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Navbar />
      <main>
        <PollioHero />
        
        {/* Value Prop Banner */}
        <section className="py-24 bg-white border-y border-slate-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-8 leading-tight">
              From Passive Watching <br />
              <span className="text-amber-600">To Active Participation.</span>
            </h2>
            <p className="text-slate-600 text-xl max-w-3xl mx-auto mb-12 leading-relaxed">
              Events with interactive polling see a 65% increase in audience retention. Pollio makes it effortless to capture attention and keep it.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {[
                { label: "Engagement Lift", value: "65%" },
                { label: "Latency", value: "< 100ms" },
                { label: "Supported Devices", value: "All" }
              ].map((stat, i) => (
                <div key={i} className="bg-amber-50 p-8 rounded-2xl border border-amber-100">
                  <p className="text-amber-600 text-4xl font-black mb-2">{stat.value}</p>
                  <p className="text-amber-900/60 text-xs font-bold uppercase tracking-widest">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <PollioFeatures />
        
        {/* New Dark Animation Section */}
        <PollioLivePreview />
        
      </main>
    </div>
  );
};

export default PollioPage;